import _ from 'lodash';
import React from 'react';
import { FormControlLabel, FormHelperText, Checkbox } from '@material-ui/core';

import { FastField } from 'formik';

import intl from '$gintl';

interface CheckboxProps {
  icon?: string;
  label?: string;
  name: string;
  disabled?: boolean;
  readonly?: boolean;
  position?: string;
  formik?: any;
  slot?: string;
  value?: any;
  handleChange?: (e) => void;
}

const defaultProps: CheckboxProps = {
  icon: '',
  label: '',
  name: '',
  disabled: false,
  readonly: false,
  formik: {},
  slot: 'end',
  value: 'on',
  handleChange: () => {},
};

const TextInput: React.FC<CheckboxProps> = ({
  icon,
  label,
  name,
  disabled,
  readonly,
  position,
  formik,
  slot,
  value,
  handleChange,
  ...props
}) => {
  const onChange = e => {
    if (formik.setFieldValue) formik.setFieldValue(name, e.target.checked);
    if (handleChange) handleChange(e);
  };

  const errorKey = _.get(formik.errors, name);
  const isTouched = _.get(formik.touched, name) !== undefined;
  const hasError = isTouched && errorKey !== undefined;
  const errorMsg = hasError ? intl(`INPUT.ERROR.${errorKey}`) : undefined;

  return (
    <>
      <FastField name={name}>
        {({ form }) => {
          return (
            <>
              <FormControlLabel
                control={
                  <Checkbox
                    {...props}
                    name={name}
                    disabled={disabled}
                    checked={!!_.get(form.values, name)}
                    onChange={onChange}
                    value={value}
                    color="primary"
                  />
                }
                label={intl(label)}
              />
              <FormHelperText>{errorMsg}</FormHelperText>
            </>
          );
        }}
      </FastField>
    </>
  );
};

TextInput.defaultProps = defaultProps;

export default TextInput;
